import { IconButton } from "@zendeskgarden/react-buttons";
import { ReactElement } from "react";
import { TUserWorkflowTask, TUserWorkflowTaskStatus } from "./logic/useUserWorkflow";
import { TaskStatusType, useSetUserWorkflowTaskStatusMutation } from "../../__generated__/generated_types";
import { Property } from "../../contexts/properties/PropertiesContext";
import { Check, CheckCircle, CheckCircleOutline } from "@material-ui/icons";
import css from "./styles/uw-status-button.module.scss";
import cn from "classnames";


export interface IUserWorkflowStatusButtonProps {
    task: TUserWorkflowTask | null;
    property?: Property;
    onTaskUpdate: (status: TUserWorkflowTaskStatus | null) => void;
}

export function UserWorkflowStatusButton({task, property, onTaskUpdate}: IUserWorkflowStatusButtonProps): ReactElement {
    const [setTaskStatus, {loading: setTaskStatusLoading}] = useSetUserWorkflowTaskStatusMutation();
    const isCompleted = task?.currentStatus?.status == TaskStatusType.Complete;

    return (
        <div className={cn(css.uwStatusButton, task?.currentStatus?.status == TaskStatusType.Complete && css.isComplete)}>
            <IconButton
                size="small"
                className={css.iconButton}
                onClick={() => {
                    if (!task || !property) {
                        return;
                    }

                    const newStatus = task.currentStatus?.status == TaskStatusType.Complete ? TaskStatusType.Pending : TaskStatusType.Complete;

                    setTaskStatus({
                        variables: {
                            taskId: task.id,
                            propertyId: property.id,
                            budgetYear: property?.budgetYear,
                            status: newStatus,
                        }}
                    ).then(({data}) => {
                        onTaskUpdate(data?.setTaskStatus ?? null);
                    });
                }}
                disabled={setTaskStatusLoading}
            >
                <>
                    {/* <CheckCircleOutline className={css.incompleteIcon} />
                    <CheckCircle className={css.completeIcon} /> */}
                    <Check className={css.checkIcon} />
                </>
            </IconButton>
            <span>{isCompleted ? `Complete` : "Incomplete"}</span>
        </div>
        // <Button
        //     onClick={() => {
        //         if (!task || !property) {
        //             return;
        //         }

        //         const newStatus = task.currentStatus?.status == TaskStatusType.Complete ? TaskStatusType.Pending : TaskStatusType.Complete;

        //         setTaskStatus({
        //             variables: {
        //                 taskId: task.id,
        //                 propertyId: property.id,
        //                 budgetYear: property?.budgetYear,
        //                 status: newStatus,
        //             }}
        //         ).then(({data}) => {
        //             onTaskUpdate(data?.setTaskStatus ?? null);
        //         });
        //     }}
        //     disabled={setTaskStatusLoading}
        // >
        //     <Button.StartIcon>
        //         <BsCheckCircle />
        //     </Button.StartIcon>
        //     {
        //         task?.currentStatus?.status == TaskStatusType.Complete ?
        //             "Mark Incomplete"
        //             : "Mark Complete"
        //     }

        //     {
        //         setTaskStatusLoading &&
        //             <Button.EndIcon>
        //                 <Dots  />
        //             </Button.EndIcon>
        //     }
        // </Button>
    );
}
